// extracted by mini-css-extract-plugin
module.exports = {"globalKnowBtn":"message_globalKnowBtn__6uUPr","withVerify":"message_withVerify__sn3xg","knowBtn":"message_knowBtn__LQy3M","verifyBtn":"message_verifyBtn__0X3UN"};